(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gga-review"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gga-reviews')) {
    customElements.define('gga-reviews', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.review-slide')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.paused = this.dataset.editor === 'true';
        this.focusPaused = false;
        this.hovered = false;
        this.inView = false;
        this.stage = this.querySelector('.review-stage');
        this.toggle = this.querySelector('[data-review-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelector('.review-controls').hidden = false;
        this.addEventListener('click', event => {
          const step = event.target.closest('[data-review-step]');
          if (step) {
            this.paused = true;
            this.show(this.index + Number(step.dataset.reviewStep));
          } else if (event.target.closest('[data-review-toggle]')) {
            this.paused = !this.paused;
            this.focusPaused = false;
            this.sync();
          }
        }, options);
        this.addEventListener('focusin', () => { this.focusPaused = true; this.sync(); }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.focusPaused = false; this.sync(); }
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        window.addEventListener('pageshow', () => this.sync(), options);
        window.addEventListener('gga:motion', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (index >= 0) { this.paused = true; this.show(index); }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.25 });
        this.observer.observe(this);
        this.show(0);
      }

      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.querySelector('[data-review-current]').textContent = this.index + 1;
        this.sync();
      }

      sync() {
        clearTimeout(this.timer);
        const motionOff = this.motion.matches || document.documentElement.dataset.motion === 'off';
        const automatic = !this.paused && !motionOff;
        this.toggle.hidden = motionOff;
        this.toggle.toggleAttribute('data-paused', this.paused);
        this.toggle.querySelector('[data-review-toggle-label]').textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        this.stage.setAttribute('aria-live', automatic && !this.focusPaused ? 'off' : 'polite');
        if (!automatic || this.focusPaused || this.hovered || !this.inView || document.hidden) return;
        // Allow extra reading time for longer reviews, with a gentle minimum pace.
        const words = this.slides[this.index].querySelector('blockquote').textContent.trim().split(/\s+/).length;
        const seconds = Math.min(11, Math.max(6, Number(this.dataset.interval) || 6, Math.ceil(words / 5) + 2));
        this.timer = setTimeout(() => this.show(this.index + 1), seconds * 1000);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gga-sale-lineup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.Shopify?.designMode) return;
  let timer;
  async function checkSale() {
    clearTimeout(timer);
    const section = document.querySelector('#sale-lineup[data-sale-state="upcoming"][data-auto-open="true"]');
    if (!section) return;
    if (!document.hidden) {
      try {
        const url = new URL(location.href);
        url.searchParams.set('sections', section.dataset.saleSection);
        url.searchParams.set('_gga_check', Date.now());
        const response = await fetch(url, {cache: 'no-store', credentials: 'same-origin'});
        if (response.ok) {
          const result = await response.json();
          const doc = new DOMParser().parseFromString(result[section.dataset.saleSection] || '', 'text/html');
          const updated = doc.querySelector('#sale-lineup');
          if (updated?.dataset.saleState === 'open' && !document.querySelector('dialog[open]') && !document.activeElement?.matches('input, select, textarea')) {
            location.reload();
            return;
          }
        }
      } catch {}
    }
    timer = setTimeout(checkSale, 15000);
  }
  timer = setTimeout(checkSale, 15000);
  window.addEventListener('pageshow', checkSale);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) checkSale(); });
})();

  } catch(e) { console.error(e); }
})();
})();
